// Keep in sync with the multer limits in server/keystone.ts
export const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024 // 25 MB
export const MAX_FILE_COUNT = 10

const formatMb = (bytes: number): string => `${Math.round((bytes / (1024 * 1024)) * 10) / 10}MB`

export function validateFileSize(
  files: File[] | FileList,
  maxSizeBytes: number = MAX_FILE_SIZE_BYTES
): string | null {
  const oversized = Array.from(files).find((file) => file.size > maxSizeBytes)
  if (!oversized) return null
  return `File "${oversized.name}" is too large (${formatMb(
    oversized.size
  )}). Maximum file size is ${formatMb(maxSizeBytes)}.`
}

export function validateFileCount(
  files: File[] | FileList,
  maxCount: number = MAX_FILE_COUNT
): string | null {
  const count = Array.from(files).length
  if (count <= maxCount) return null
  return `Too many files selected (${count}). Maximum is ${maxCount} files per upload.`
}
